import { useEffect, useRef } from "react";
import { mailApiPost } from "@/lib/api/client";

const PRESENCE_INTERVAL_MS = 45_000;

/**
 * Signale au worker que l’utilisateur regarde ce compte (scheduler adaptatif).
 * Onglet visible uniquement — pas de trafic en arrière-plan.
 */
export function useMailWorkerPresence(
  accountId: number | undefined,
  folder?: string
): void {
  const folderRef = useRef(folder ?? "INBOX");
  folderRef.current = folder ?? "INBOX";

  useEffect(() => {
    if (accountId == null || accountId < 1) return;

    let cancelled = false;
    let timer: number | null = null;

    const ping = () => {
      if (cancelled || document.visibilityState !== "visible") return;
      void mailApiPost("worker/presence.php", {
        accountId,
        folder: folderRef.current,
      });
    };

    const schedule = () => {
      if (timer != null) window.clearInterval(timer);
      if (document.visibilityState !== "visible") return;
      ping();
      timer = window.setInterval(ping, PRESENCE_INTERVAL_MS);
    };

    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        schedule();
      } else if (timer != null) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    schedule();
    document.addEventListener("visibilitychange", onVisibility);

    return () => {
      cancelled = true;
      document.removeEventListener("visibilitychange", onVisibility);
      if (timer != null) window.clearInterval(timer);
    };
  }, [accountId]);
}
